import { Button, Dropdown } from '../../components';

import React, { cloneElement } from 'react';
import { get, map } from 'lodash';

const DownloadsPicker = ({ modes }) => {
  const dropdownOptions = map(modes, ({ text, download }, mode) => ({
    key: mode,
    value: mode,
    content: cloneElement(download, {
      trigger: <Dropdown.Item text={text} />,
    }),
  }));

  return (
    <Button.Group primary>
      {cloneElement(get(Object.values(modes), [0, 'download']), {
        trigger: <Button icon="download" content="Download" />,
      })}
      <Dropdown options={dropdownOptions} floating button />
    </Button.Group>
  );
};

export default DownloadsPicker;



// WEBPACK FOOTER //
// ./src/pages/Home/DownloadsPicker.js